import React, { useState, useEffect } from "react";
import Vector from "../../../assets/svg/editIcon.svg";
import Delete from "../../../assets/svg/DeleteIcon.svg";
import ReactPaginate from "react-paginate";
import { ToastContainer, toast } from "react-toastify";
import CommonFooter from "../../../CommonFooter/CommonFooter";
import MailHeader from "../MailHeader";
import axiosInstance from "../../../axiosInstance";
import { useNavigate, useLocation } from 'react-router-dom';
import { usePermissions } from "../../../hooks/PermissionContext";
import PermissionWrapper from "../../../hooks/PermissionWrapper";

const MailTemplateListingPage = () => {
  let ModuleId = 28
  const { getModulePermission } = usePermissions();
  const permission = getModulePermission(ModuleId);
  console.log("activeModuleId", ModuleId);

  const [tableData, setTableData] = useState([]);
  const [limit, setLimit] = useState(5);
  const [currentPage, setCurrentPage] = useState(0);
  const [totalCount, setTotalCount] = useState(0);
  const [loading, setLoading] = useState(false);
  const [skip, setSkip] = useState(0);
  const [total, setTotal] = useState(0);
  const totalPages = Math.ceil(totalCount / limit);

  const navigate = useNavigate();

  const fetchMailTemplates = async () => {
    try {
      setLoading(true);

      const response = await axiosInstance.get("/mail_template/list", {
        params: {
          limit,
          skip: currentPage * limit,
        },
      });

      if (response.data.success) {
        setTableData(response.data.mail_template || []);
        setTotalCount(response.data.totalCount || 0);
      } else {
        setTableData([]);
      }
    } catch (error) {
      console.error("Error fetching mail templates:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleDelete = async (id) => {
    try {
      setLoading(true);

      const response = await axiosInstance.delete(
        `/mail_template/delete/${id}`
      );

      if (response.data.success) {
        toast.success(response.data.message || "Deleted successfully");
        if (tableData.length === 1 && currentPage > 0) {
          setCurrentPage((prev) => prev - 1);
        } else {
          fetchMailTemplates();
        }
      } else {
        toast.error(response.data.message || "Delete failed");
      }
    } catch (error) {
      console.error("Delete error:", error);
      toast.error("Something went wrong");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchMailTemplates();
  }, [currentPage, limit]);

  const handlePageClick = ({ selected }) => {
    setCurrentPage(selected);
  };

  const handleLimitChange = (e) => {
    const newLimit = Number(e.target.value);
    setLimit(newLimit);
    setCurrentPage(0);
  };

  const handleAddNewClick = () => {
    navigate("/MailTemplateCreation");
  };

  const handleRowClick = (rowId) => {
    navigate('/mailTemplateViewPage', {
      state: { rowId }
    });
  };


  const handleEditClick = async (mailId) => {
    try {
      const response = await axiosInstance.get(`/mail_template/edit/${mailId}`);
      if (response.data) {
        navigate('/mailTemplateCreation', {
          state: {
            editDataResponse: response.data,
            isEditMode: true,
            mailId
          }
        });
      } else {
        toast.error("No data received for this role");
      }
    } catch (error) {
      toast.error("Failed to fetch role details");
      console.error("Error fetching role:", error);
    }
  };

  return (
    <>
      <MailHeader />

      <div className="container">
        {/* HEADER */}
        <div className="header">
          <div className="left-header">
            <h3>Mail Template ({totalCount})</h3>
          </div>
          <PermissionWrapper permissionKey="create_permission" moduleId={ModuleId}>
            <div className="right-header">
              <button id="addNewBtn" onClick={handleAddNewClick}>
                Add New
              </button>
            </div>
          </PermissionWrapper>
        </div>

        {/* TABLE */}
        <div style={{ overflowX: 'auto', whiteSpace: 'nowrap', scrollbarWidth: 'none', OverflowStyle: 'none', WebkitOverflowScrolling: 'touch', scrollBehavior: 'smooth' }}>
          <table >
            <thead>
              <tr>
                <th style={{ width: "50px", textAlign: "center" }}>S.No</th>
                <th>Title</th>
                <th>Subject</th>
                <th>Status</th>
                <th>Modified Date</th>
                <th></th>
              </tr>
            </thead>

          <tbody>
            {loading ? (
              <tr>
                <td colSpan="5" style={{ textAlign: "center" }}>
                  Loading...
                </td>
              </tr>
            ) : tableData.length > 0 ? (
              tableData.map((row, index) => (
                <tr key={row.id}>
                  <td style={{ textAlign: "center" }}>
                    {currentPage * limit + index + 1}
                  </td>

                  <td
                    onClick={() => handleRowClick(row.id)}
                    style={{ cursor: "pointer" }}
                  >
                    {row.title}
                  </td>

                  <td
                    onClick={() => handleRowClick(row.id)}
                    style={{ cursor: "pointer" }}
                  >
                    {row.subject}
                  </td>

                  <td
                    onClick={() => handleRowClick(row.id)}
                    style={{ cursor: "pointer" }}
                  >
                    <span
                      style={{
                        display: "inline-flex",
                        alignItems: "center",
                        gap: "6px",
                        padding: "4px 10px",
                        borderRadius: "12px",
                        backgroundColor: row.status
                          ? "#E7F6EC"
                          : "#FDEAEA",
                        color: row.status ? "#2E7D32" : "#C62828",
                        fontSize: "12px",
                        fontWeight: 600,
                      }}
                    >
                      <span
                        style={{
                          width: "8px",
                          height: "8px",
                          borderRadius: "50%",
                          backgroundColor: row.status
                            ? "#2E7D32"
                            : "#C62828",
                        }}
                      />
                      {row.status ? "Active" : "Inactive"}
                    </span>
                  </td>
                  <td>{row.modifieddate}</td>

                  <td>
                    <div className="actions" style={{ gap: "10px" }}>
                      <PermissionWrapper permissionKey="edit_permission" moduleId={ModuleId}>
                        <span
                          onClick={(e) => {
                            e.stopPropagation();
                            handleEditClick(row.id)
                          }}
                          className="edit-icon"
                          title="Edit"
                          style={{
                            cursor: "pointer",
                            width: "30px",
                            height: "30px",
                            display: "inline-flex",
                            alignItems: "center",
                            justifyContent: "center",
                            borderRadius: "50%",
                            backgroundColor: "#fff",
                          }}
                        >
                          <img src={Vector} alt="Edit" width="14" height="14" />
                        </span>
                      </PermissionWrapper>

                      {/* <PermissionWrapper permissionKey="delete_permission" moduleId={ModuleId}>
                        <span
                          className="delete-icon"
                          title="Delete"
                          onClick={(e) => {
                            e.stopPropagation();
                            handleDelete(row.id);
                          }}
                          style={{
                            cursor: "pointer",
                            width: "30px",
                            height: "30px",
                            display: "inline-flex",
                            alignItems: "center",
                            justifyContent: "center",
                            borderRadius: "50%",
                            backgroundColor: "#fff",
                          }}
                        >
                          <img src={Delete} alt="Delete" width="27" height="27" />
                        </span>
                      </PermissionWrapper> */}
                    </div>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="5" style={{ textAlign: "center" }}>
                  No data found
                </td>
              </tr>
            )}
          </tbody>
        </table>
        </div>

        {/* PAGINATION */}
        <div className="invoice-pagination-container d-flex align-items-center justify-content-between mt-3">
          <div className="Limit-Dropdown">
            <label htmlFor="limit" className="fw-semibold">Items per page:</label>
            <select
              id="limit"
              value={limit}
              onChange={handleLimitChange}
              className="invoice-form-select d-inline w-auto"
            >
              <option value="5">5</option>
              <option value="10">10</option>
              <option value="25">25</option>
              <option value="50">50</option>
            </select>
          </div>

          <div className="invoice-react-page d-flex align-items-center gap-4">
            <ReactPaginate
              previousLabel="Previous"
              nextLabel="Next"
              pageCount={totalPages}
              onPageChange={handlePageClick}
              forcePage={currentPage}
              containerClassName="pagination"
              pageClassName="page-item"
              pageLinkClassName="page-link"
              previousClassName="page-item"
              previousLinkClassName="page-link"
              nextClassName="page-item"
              nextLinkClassName="page-link"
              activeClassName="active"
              breakLabel="..."
              breakClassName="page-item"
              breakLinkClassName="page-link"
              marginPagesDisplayed={1}
              pageRangeDisplayed={3}
              disabledClassName="disabled"
            />
          </div>
        </div>
      </div>

      <CommonFooter />
      <ToastContainer position="top-right" autoClose={3000} />
    </>
  );
};

export default MailTemplateListingPage;
